import { getElectronAPI } from 'flow/utils/electron-api';
import { addUserPhoneLogEntry } from 'flow/utils/browser-utils';

/**
 * Ask the desktop app to put its window on screen, for the cases a hidden companion cannot handle
 * alone - a sign-in, the feature being off, another machine taking the role.
 *
 * The main process ignores this when the window is already visible, so callers need not check.
 * No-op outside the desktop app.
 */
export const revealDesktopWindow = (reason: string) => {
    const electronAPI = getElectronAPI();
    if (!electronAPI) {
        return;
    }

    addUserPhoneLogEntry(`Revealing the window: ${reason}`);
    electronAPI.revealWindow();
};
